import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { Banner, BannerItem, Container, Spinner, TBgColor } from 'telia-front-react';
import JsxRenderer from '../content/JsxRenderer';
import BannersStore, { BannerData } from '../stores/BannersStore';
import { FetchStatus } from '../util/FetchStatus';

interface FrontPageCarouselProps {
  bannersStore?: BannersStore;
}

@observer
class FrontPageCarousel extends Component<FrontPageCarouselProps> {
  public componentDidMount() {
    this.props.bannersStore.fetchBanners();
    this.props.bannersStore.subscribeToCustomerChangeReaction();
  }
  public componentWillUnmount() {
    this.props.bannersStore.unsubscribeToCustomerChangeReaction();
  }

  public render() {
    const { bannersStore } = this.props;

    if ([FetchStatus.UNINITIALIZED, FetchStatus.FETCHING].includes(bannersStore.status)) {
      return <Spinner />;
    }

    return (
      <>
        <Banner
          background={(bannersStore.bannersToDisplay.length && (bannersStore.bannersToDisplay[0].backgroundColor as TBgColor)) || null}
          variant={bannersStore.bannersToDisplay.length && bannersStore.bannersToDisplay[0].backgroundColor ? 'dark' : null}
        >
          {bannersStore.bannersToDisplay.map((banner: BannerData, index: number) => (
            <BannerItem
              id={`banner-item-${index.toString()}`}
              key={`banner-hero-${index}`}
              image={
                banner.desktopImage && {
                  srcset: bannersStore.getMobileSrcSetForBanner(index),
                  alt: banner.title,
                  align: 'center',
                  sources: [
                    {
                      minWidth: '1000px',
                      srcset: bannersStore.getDesktopSrcSetForBanner(index),
                    },
                  ],
                }
              }
            >
              <Container>
                <JsxRenderer key={index} jsx={banner.content} showErrorNotice={false} />
              </Container>
            </BannerItem>
          ))}
        </Banner>
      </>
    );
  }
}

export default inject('bannersStore')(FrontPageCarousel);
